module.exports = __webpack_public_path__ + "img/documento-aprovado.23573865.svg";